import React from 'react';

interface Props {
  status?: string;
  adjustedDate?: string;
  adjustedTime?: string;
}

const InventoryAdjustmentStatusBar: React.FC<Props> = ({
  status,
  adjustedDate,
  adjustedTime,
}) => {
  if (!status && !adjustedDate && !adjustedTime) return null;

  return (
    <div className="mb-3 flex items-center justify-between rounded-md bg-gray-50 px-4 py-2 text-sm">
      {/* ESTADO */}
      <div className="font-medium text-gray-700">
        Estado:&nbsp;
        <span className="text-primary">{status}</span>
      </div>

      {/* FECHA + HORA */}
      <div className="text-gray-500">
        {adjustedDate} {adjustedTime}
      </div>
    </div>
  );
};

export default InventoryAdjustmentStatusBar;
